import type { Soldier } from './military';

/** Interleave original factions without dropping the tail of a partial roster. */
export function combatTurn(friendly: Soldier[], hostile: Soldier[], index: number): Soldier | undefined {
  const paired = Math.min(friendly.length, hostile.length);
  return index < paired * 2
    ? (index % 2 ? hostile : friendly)[Math.floor(index / 2)]
    : (friendly.length > paired ? friendly : hostile)[index - paired];
}

/** A temporary fall or an off-camera seat does not remove an original reserve
 * from the outcome. Incapacitated people remain available to ordinary care. */
export function combatCapable(s: Soldier): boolean {
  return (
    !s.person.fatal &&
    !s.person.demobilised &&
    !['incapacitated', 'carried', 'recovering'].includes(s.person.state) &&
    !['lost', 'withdrawn'].includes(s.state)
  );
}
export function rosterCounts(roster: Soldier[]): Record<string, number> {
  const result = {
    total: roster.length,
    dead: 0,
    lost: 0,
    incapacitated: 0,
    withdrawn: 0,
    aboard: 0,
    airborne: 0,
    deployed: 0,
    combatCapable: 0,
  };
  for (const s of roster) {
    const p = s.person;
    if (p.fatal) result.dead++;
    else if (s.state === 'lost') result.lost++;
    else if (['incapacitated', 'carried', 'recovering'].includes(p.state)) result.incapacitated++;
    else if (p.demobilised || s.state === 'withdrawn') result.withdrawn++;
    else if (p.carrier) result.aboard++;
    else if (s.state === 'airborne' || p.state === 'falling') result.airborne++;
    else result.deployed++;
    if (combatCapable(s)) result.combatCapable++;
  }
  return result;
}
export function invasionOutcome(
  friendly: Soldier[],
  hostile: Soldier[],
  reserves: number,
  cityLost: boolean,
): string | undefined {
  if (!friendly.some(combatCapable)) return 'Defending force has no combat-capable survivors';
  if (reserves === 0 && !hostile.some(combatCapable)) return 'Hostile force has no combat-capable survivors';
  if (cityLost) return 'City lost: 99% of activation structural capacity unusable';
  return;
}
